module.exports = __webpack_public_path__ + "659d68ad8e989631ecaae0ee2d79c47f.png";